import React, { useEffect, useState } from 'react';

export default function PremiumDetailsPage() {
  const [region, setRegion] = useState('IN');
  const [price, setPrice] = useState('₹149');

  useEffect(() => {
      const detectRegion = async () => {
        try {
          const res = await fetch('https://ipapi.co/json/');
          const data = await res.json();
          const countryCode = data.country_code;
          switch (countryCode) {
            case 'IN':
              setRegion('IN');
              setPrice('₹149');
              break;
            case 'US':
              setRegion('US');
              setPrice('$5');
              break;
            default:
              setRegion('INTL');
              setPrice('$5');
          }
        } catch (err) {
          console.error('Geo detection failed', err);
          // Fallback to navigator.language
          const lang = navigator.language || '';
          if (lang.includes('en-US')) {
            setRegion('US');
            setPrice('$5');
          } else {
            setRegion('IN');
            setPrice('₹149');
          }
        }
      };
      detectRegion();
    }, []);

  return (
    <div className="max-w-4xl mx-auto p-6 mt-12 text-center">
      <h1 className="text-4xl font-bold text-gray-800 mb-4">Poppyruz Premium</h1>
      <p className="text-gray-600 text-lg mb-10">
        Support Poppyruz and unlock the full reading experience — forever.
      </p>

      {/* Plans Comparison */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-12 text-left">
        <div className="bg-white border rounded shadow p-6">
          <h2 className="text-xl font-bold text-blue-600 mb-3">Free</h2>
          <ul className="list-disc ml-5 space-y-2 text-gray-700 text-sm">
            <li>Read all public domain books</li>
            <li>Upload up to 4 personal books</li>
            <li>Basic reading themes</li>
            <li>Ads during usage</li>
          </ul>
        </div>

        <div className="bg-yellow-50 border-yellow-300 border rounded shadow p-6">
          <h2 className="text-xl font-bold text-yellow-700 mb-3">Premium – One-Time {price}</h2>
          <ul className="list-disc ml-5 space-y-2 text-gray-800 text-sm">
            <li>Unlimited book uploads</li>
            <li>Upload your own themes (image + audio)</li>
            <li>Access all premium visual/audio themes</li>
            <li>Remove all ads forever</li>
          </ul>
          <p className="text-xs text-gray-500 italic mt-3">
            No subscriptions. One-time payment. Lifetime access.
          </p>
        </div>
      </div>

      {/* Payment Info Section */}
      <div className="bg-gray-50 border rounded-lg p-5 shadow-sm text-sm text-left text-gray-800 max-w-xl mx-auto mb-8">
        <p className="mb-3">
          To upgrade your account, please log in or sign up first. Premium access is only available to registered users.
        </p>

        <div className="flex justify-center gap-4 mt-4">
          <button
            onClick={() => {
                window.location.href = `/`;
            }}
            className="bg-blue-600 text-white px-5 py-2 rounded hover:bg-blue-700 transition text-sm"
          >
            Home
          </button>
        </div>
      </div>

      <p className="text-xs text-gray-500 italic text-center">
        We're a small indie team. Thank you for supporting us 💛
      </p>
    </div>
  );
}
